import {inQueue, getQueueClone, outQueue} from './queue.js'
import {getQueueRunStatus, nextQueue, observePopup} from "./event.js";

function inputPopupQueue(target, priority, executeCallback) {
    if (Often.null2Void(target) === "") {
        console.error("There is no target of the popup inputting to the popup queue.");
        return;
    }

    const queue = getQueueClone();
    if (Often.null2Void(priority) === "") priority = queue[queue.length - 1].priority + 1;

    inQueue(target, priority, executeCallback);
    if (!getQueueRunStatus() && getQueueClone().length > 0) {
        observePopup(outQueue(), nextQueue);
    }
}

export {inputPopupQueue, getQueueClone}